import React from "react";
import { MenuItem, Box } from "@material-ui/core";
import mergeClasses from "classnames";
import { DPSpacer } from "Components/DP";
import ProviderIcon from "./ProviderIcon";
import { CheckmarkIcon } from "Components/Icons";
import { usePartnerConfig } from "Hooks/usePartnerConfig";
import useStyles from "./styles";
import { useSwitchProvider } from "./useSwitchProvider";
import { Provider } from "generated/graphql";
import { useNetworkStatus } from "Api/GraphQL/ApolloNetworkStatus";
import { errorToast } from "Modules/DPToast";

type ProviderSelectMenuItemProps = {
  provider: Provider;
};

const ProviderSelectMenuItem = ({
  provider,
}: ProviderSelectMenuItemProps) => {
  const { currentProvider } = usePartnerConfig();
  const isCurrentProvider =
    currentProvider && currentProvider.id === provider.id;
  // https://github.com/mui-org/material-ui/issues/14018
  const classes = useStyles({});
  const checkmarkClassName = mergeClasses(
    isCurrentProvider && classes.currentProvider,
    classes.menuCheckmark
  );

  const { onSwitchProvider } = useSwitchProvider(provider);
  const { numPendingMutations, numPendingQueries } = useNetworkStatus();

  const handleClick = () => {
    if (numPendingQueries || numPendingMutations) {
      errorToast("Your request cannot be completed, while the page is loading.");
      return;
    }

    if (!isCurrentProvider) {
      onSwitchProvider();
    }
  };

  return (
    <MenuItem className={classes.menuItem} disableGutters onClick={handleClick}>
      <CheckmarkIcon className={checkmarkClassName} />
      <DPSpacer spacing={2} />
      <ProviderIcon icon={provider.icon || ""} />
      <DPSpacer />
      <Box mr={4}>{provider.name}</Box>
    </MenuItem>
  );
};

export default ProviderSelectMenuItem;
